import { render } from "./stat_dashboard.vue?vue&type=template&id=cac1ac96"
import script from "./stat_dashboard.vue?vue&type=script&lang=js"
export * from "./stat_dashboard.vue?vue&type=script&lang=js"

import exportComponent from "D:\\projects\\swan\\paybuistra\\paybuistra-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__